// Copyright (c) 2016 Deere & Company

import DealerSettings from '../../user/dealer-settings/state-connector';

export default {
    component: DealerSettings,
    name: 'DEALER_LOCATION',
    path: 'dealer'
};



// WEBPACK FOOTER //
// ./src/routes/settings/dealer.js